module.exports = __webpack_public_path__ + "static/media/13.69d64f7d.jpeg";